export enum CustomDashboardManagementTypeEnum {
  IFRAME = '7c4417b7-2456-41a2-ae16-ead01046b94f',
  METABASE = 'cbcd80c5-e2ec-44ff-a58d-aebda3344e98',

}

